import React from "react";

const ErrorPage: React.FC = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Oops! Page Not Found</h1>
      <p>The page you're looking for does not exist.</p>
    </div>
  );
};

export default ErrorPage;
